export const benefitsByState = {
  default: {
    name: null,
    benefits: [
      {
        key: 'leafwellMoneyBack',
        title: 'Approved or your money back',
      },
      {
        key: 'leafwellOnline',
        title: '100% online, from any device',
      },
      {
        key: 'leafwellDoctors',
        title: 'Doctors available 7 days a week',
      },
    ],
  },
  states: {
    alaska: {
      name: 'Alaska',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 5% on products',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
        {
          key: 'cultivation',
          title: 'Cultivation',
        },
      ],
    },
    arizona: {
      name: 'Arizona',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 16% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    arkansas: {
      name: 'Arkansas',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
      ],
    },
    california: {
      name: 'California',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'taxSavings',
          title: 'Save up to 10.25% on products',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    colorado: {
      name: 'Colorado',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 12% on products',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
        {
          key: 'leafwellMoneyBack',
          title: 'Approved or your money back',
        },
      ],
    },
    connecticut: {
      name: 'Connecticut',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 24% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    delaware: {
      name: 'Delaware',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 15% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    florida: {
      name: 'Florida',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Only legal way to access marijuana',
        },
        {
          key: 'leafwellMoneyBack',
          title: 'Approved or your money back',
        },
      ],
    },
    georgia: {
      name: 'Georgia',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'higherPossession',
          title: 'Higher possession',
        },
        {
          key: 'leafwellMoneyBack',
          title: 'Approved or your money back',
        },
      ],
    },
    guam: {
      name: 'Guam',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 15% on products',
        },
        {
          key: 'higherPossession',
          title: 'Higher possession',
        },
        {
          key: 'leafwellMoneyBack',
          title: 'Approved or your money back',
        },
      ],
    },
    hawaii: {
      name: 'Hawaii',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'higherPossession',
          title: 'Higher possession',
        },
      ],
    },
    illinois: {
      name: 'Illinois',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'taxSavings',
          title: 'Pay 1% sales tax instead of up to 37%',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections as a registered patient',
        },
      ],
    },
    iowa: {
      name: 'Iowa',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
        {
          key: 'higherPossession',
          title: 'Higher possession',
        },
      ],
    },
    kentucky: {
      name: 'Kentucky',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
        {
          key: 'higherPossession',
          title: 'Higher possession',
        },
      ],
    },
    louisiana: {
      name: 'Louisiana',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
        {
          key: 'higherPossession',
          title: 'Higher possession',
        },
      ],
    },
    maine: {
      name: 'Maine',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 10% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    maryland: {
      name: 'Maryland',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 12% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    massachusetts: {
      name: 'Massachusetts',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 20% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    michigan: {
      name: 'Michigan',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 10% on products',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
      ],
    },
    minnesota: {
      name: 'Minnesota',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Pay no cannabis tax on medical products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    mississippi: {
      name: 'Mississippi',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
        {
          key: 'higherPossession',
          title: 'Higher possession',
        },
      ],
    },
    missouri: {
      name: 'Missouri',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 8% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    montana: {
      name: 'Montana',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 16% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for housing',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    nevada: {
      name: 'Nevada',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 10% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    'new-hampshire': {
      name: 'New Hampshire',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
        {
          key: 'higherPossession',
          title: 'Legal Possession',
        },
      ],
    },
    'new-jersey': {
      name: 'New Jersey',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 7% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    'new-mexico': {
      name: 'New Mexico',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 12% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    'new-york': {
      name: 'New York',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 13% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    'north-dakota': {
      name: 'North Dakota',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'legalProtection',
          title: 'Legal protection',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 19+',
        },
      ],
    },
    ohio: {
      name: 'Ohio',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 10% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    oklahoma: {
      name: 'Oklahoma',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
      ],
    },
    oregon: {
      name: 'Oregon',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 20% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
      ],
    },
    pennsylvania: {
      name: 'Pennsylvania',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
      ],
    },
    'rhode-island': {
      name: 'Rhode Island',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 6% on products',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'higherPossession',
          title: 'Higher possession',
        },
      ],
    },
    texas: {
      name: 'Texas',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'No minimum age — minors qualify with a guardian',
        },
        {
          key: 'higherPossession',
          title: 'Higher possession',
        },
      ],
    },
    utah: {
      name: 'Utah',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
        {
          key: 'higherPossession',
          title: 'Higher possession',
        },
      ],
    },
    vermont: {
      name: 'Vermont',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 20% on products',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
      ],
    },
    virginia: {
      name: 'Virginia',
      benefits: [
        {
          key: 'taxSavings',
          title: 'No state fee, no registration',
        },
        {
          key: 'accessToProducts',
          title: 'Access to lab-tested medical products',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
      ],
    },
    washington: {
      name: 'Washington',
      benefits: [
        {
          key: 'taxSavings',
          title: 'Save up to 37% on products',
        },
        {
          key: 'accessToProducts',
          title: 'Access higher-potency cannabis products',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
      ],
    },
    'washington-d-c': {
      name: 'Washington, D.C.',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
        {
          key: 'leafwellMoneyBack',
          title: 'Approved or your money back',
        },
      ],
    },
    'west-virginia': {
      name: 'West Virginia',
      benefits: [
        {
          key: 'accessToDispensaries',
          title: 'Access to dispensaries',
        },
        {
          key: 'legalProtection',
          title: 'Enjoy legal protections for employment',
        },
        {
          key: 'lowerAgeRestriction',
          title: 'Get legal cannabis at age 18+, rather than 21+',
        },
      ],
    },
  },
};
